import React, { useContext } from 'react';
import style from './style';
import EAButton from '../../../../../components/common/EAButton';
import i18next from 'i18next';
import ROUTES from '../../../../../config/Routes';
import { useHistory } from 'react-router';
import { Context } from '../../../../../states/Store';
import EAIcon from '../../../../../components/common/EAIcon';
import { useFormContext } from 'react-hook-form';

const ExistingTP = ({isTpPresent}) => {
  const {classes} = style();
  const history = useHistory();
  const [state, ] = useContext(Context);
  const { getValues } = useFormContext();

  return <div className={classes.root}>
    <div className={classes.successIconWrapper}>
      <EAIcon
        icon={'demandes/lock_gray'}
        className={classes.successIcon}
      />
    </div>
    <div className={classes.title}>
      {i18next.t('thirdpartySheet.contextTp.existingTp')}
    </div>
    <div className={classes.contextReference}>
      {getValues('context.reference')}
    </div>
    <div className={classes.content}>
      <EAButton
        content={i18next.t('thirdpartySheet.contextTp.seeContextGeneral')}
        colorVariant={'primaryLight'}
        onClick={() =>
          history.replace(
            `/${state.account.id}/${ROUTES.CONTEXT}?instance=${
              isTpPresent.ctxInstanceId
            }`
          )
        }
      />
      <EAButton
        content={i18next.t('thirdpartySheet.contextTp.seeContextTiers')}
        onClick={() =>
          history.replace(
            `/${state.account.id}/${ROUTES.CONTEXT}?instance=${
              isTpPresent.ctxInstanceId
            }&thirdparty=${isTpPresent.id}`
          )
        }
      />
    </div>
  </div>
}

export default ExistingTP;